export default __webpack_public_path__ + "static/breadcrumbs-current-item-dont-dark-9a91c6ec691f8fd2595c466541069f0e1d544f8261c9f1bfbaf10f2887ec49be.png";